import { useEffect } from 'react';
import {useTranslation} from 'react-i18next';
import { loadModules } from 'esri-loader';
import { IFeature } from '@esri/arcgis-rest-types';
import ConfigService from '../../../shared/configService';
import PopupTemplate from '@arcgis/core/PopupTemplate';

interface IProps {
    reportId: string | undefined;
    activitiesPointFeatures: IFeature[];
    activitiesPolygonFeatures: IFeature[];
    onSelectedFeature: any;
}


    
export const ActivitiesMap = (props: IProps) => {
    const {t} = useTranslation('detaildashboard');
    let mapView: any;

    // Renderer
    const pointsRenderer = {
        type: 'simple',
        symbol: {
        type: 'simple-marker',
        size: 10,
        color: ConfigService.getConfig().dashboard.map.countriesLayer.symbol.fillColor,
        outline: {  
            width: ConfigService.getConfig().dashboard.map.countriesLayer.symbol.outline.width,
            color: ConfigService.getConfig().dashboard.map.countriesLayer.symbol.outline.color
        }
        }
    };

    const polygonsRenderer = {
        type: "simple",
        symbol: {
        type: "simple-fill", 
        color: ConfigService.getConfig().dashboard.map.countriesLayer.symbol.fillColor,
        outline: {  
            width: ConfigService.getConfig().dashboard.map.countriesLayer.symbol.outline.width,
            color: ConfigService.getConfig().dashboard.map.countriesLayer.symbol.outline.color
        }
        }
    };


    /**
     * Load
     */
    useEffect(() => {   
        loadMap();
    }, []);

    const onSelectedFeature = (gid:string) => {
        props.onSelectedFeature(gid);
      }

    /**
     * Load the map
     */
    const loadMap = async () => {
        loadModules(
            ['esri/Map', 'esri/views/MapView'],
            { css: true }
        ).then(([Map, MapView]) => {            
            const map = new Map({
            basemap: 'topo',
            });

            mapView = new MapView({
                container: 'detailsActivitiesMap',
                map: map,
                center: [-2.405969, 14.0043],
                zoom: 3
            });

            mapView.when(() => {
                loadActivities();
            }, (error: any) => {
                console.error(error);
            });
        });
    }

    /**
     * Load activities
     */
     const loadActivities = async () => {
        loadModules(
            ['esri/layers/FeatureLayer'],
            { css: true }
          ).then( async ([FeatureLayer]) => {
            try {                
                if (props.reportId && (props.activitiesPointFeatures && props.activitiesPointFeatures.length) || (props.activitiesPolygonFeatures && props.activitiesPolygonFeatures.length)) {
                    const layerIndex: number = props.activitiesPointFeatures && props.activitiesPointFeatures.length ? ConfigService.getConfig().agol.operationalLayers.activitiesPoints.index : ConfigService.getConfig().agol.operationalLayers.activitiesPolygons.index;
                    const where: string = `${ConfigService.getConfig().agol.operationalLayers.activitiesFields.reportId} = '${props.reportId}'`;

                    const fl = new FeatureLayer({
                        url: `${ConfigService.getConfig().agol.operationalLayers.consultURL}/${layerIndex}`,
                        definitionExpression: where,
                        minScale: 0,
                        popupTemplate: new PopupTemplate({
                            title: ConfigService.getConfig().dashboard.detail.activitiesMapPopup.title,
                            content: [{
                                type: 'fields',
                                fieldInfos: ConfigService.getConfig().dashboard.detail.activitiesMapPopup.fieldsInfos
                            }]
                        }),
                        renderer: props.activitiesPointFeatures && props.activitiesPointFeatures.length ? pointsRenderer : polygonsRenderer
                    });
                    
                    mapView.map.add(fl);
                    
                    const query = {
                        outFields: ['*'],
                        returnGeometry: true,
                        where: where
                    }

                    const res = await fl.queryFeatures(query);

                    if (res && res.features) {
                        mapView.goTo(res.features);
                    }
                }
            }
            catch(err: any) {
                console.error(err);
            }      
        });
    }

    return (
        <div className="detailsActivitiesMapContainer">
            <div className="headerNumAndTitle">
                <span className="headerTitle">{t('activities')}</span>
            </div>
            <div>
            <div id="detailsActivitiesMap" className="mapDiv"></div>
            </div>
        </div>
    )
}

export default ActivitiesMap;